import React from "react";
import { ColId, StatusIcon } from "./prs";

const Ring = ({ dash }: { dash?: boolean }) => (
  <circle
    cx="7"
    cy="7"
    r="6"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeDasharray={dash ? "2.4 2" : undefined}
  />
);

const Svg14 = ({ children }: { children: React.ReactNode }) => (
  <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">
    {children}
  </svg>
);

export const STATUS_ICONS: Record<StatusIcon, React.ReactElement> = {
  neutral: (
    <Svg14>
      <Ring />
    </Svg14>
  ),
  author: (
    <Svg14>
      <Ring dash />
    </Svg14>
  ),
  you: (
    <Svg14>
      <Ring />
      <path d="M7 3.5a3.5 3.5 0 0 1 0 7z" fill="currentColor" />
    </Svg14>
  ),
  ok: (
    <Svg14>
      <circle cx="7" cy="7" r="7" fill="currentColor" />
      <path
        d="M4.2 7.3l1.9 1.9 3.7-4"
        fill="none"
        stroke="#fff"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg14>
  ),
  bad: (
    <Svg14>
      <circle cx="7" cy="7" r="7" fill="currentColor" />
      <path
        d="M4.8 4.8l4.4 4.4M9.2 4.8l-4.4 4.4"
        stroke="#fff"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Svg14>
  ),
};

const Line14 = ({ children }: { children: React.ReactNode }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.3"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {children}
  </svg>
);
const PERSON = (
  <>
    <circle cx="7" cy="4.5" r="2.3" />
    <path d="M2.8 12.2c.5-2.2 2.2-3.4 4.2-3.4s3.7 1.2 4.2 3.4" />
  </>
);

export const FIELD_ICONS: Partial<Record<ColId, React.ReactElement>> = {
  ci: (
    <Line14>
      <circle cx="7" cy="7" r="5.5" />
      <circle cx="7" cy="7" r="2" fill="currentColor" />
    </Line14>
  ),
  repo: (
    <Line14>
      <path d="M3 2.5h7.5v9H4a1 1 0 0 1-1-1z" />
      <path d="M3 10.5a1 1 0 0 1 1-1h6.5" />
    </Line14>
  ),
  author: <Line14>{PERSON}</Line14>,
  reviewer: (
    <Line14>
      {PERSON}
      <path d="M9.8 3.2l1 1 1.8-2" />
    </Line14>
  ),
  status: (
    <Line14>
      <circle cx="7" cy="7" r="5.5" strokeDasharray="2.2 1.8" />
    </Line14>
  ),
  draft: (
    <Line14>
      <path d="M9.5 2.5l2 2L5 11H3V9z" />
    </Line14>
  ),
  involves: <Line14>{PERSON}</Line14>,
};

const Line16 = ({ children }: { children: React.ReactNode }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.4"
    strokeLinecap="round"
  >
    {children}
  </svg>
);

export const FILTER_ICON = (
  <Line16>
    <path d="M2.5 4h11M4.5 8h7M6.5 12h3" />
  </Line16>
);
export const SLIDERS_ICON = (
  <Line16>
    <path d="M2.5 5h6M11.5 5h2M2.5 11h2M7.5 11h6" />
    <circle cx="10" cy="5" r="1.5" />
    <circle cx="6" cy="11" r="1.5" />
  </Line16>
);
export const REFRESH_ICON = (
  <Line16>
    <path d="M13 8a5 5 0 1 1-1.5-3.5M13 2.5v3h-3" />
  </Line16>
);
export const SAVE_ICON = (
  <Line16>
    <path d="M4.5 2.5h7v11L8 11l-3.5 2.5z" strokeLinejoin="round" />
  </Line16>
);
